import { useContext } from 'react';
import { INotificationService } from './INotificationService';
import { NotificationContext } from './NotificationContext';

/**
 * Hook um den Notification Service zu erhalten
 * Wird von der API-Schicht verwendet (optional)
 */
export function useNotificationService(): INotificationService | null {
  const context = useContext(NotificationContext);
  return context?.notificationService || null;
}
